import { render, staticRenderFns } from "./ot-autocomplete.vue?vue&type=template&id=53628a72&scoped=true&"
import script from "./ot-autocomplete.vue?vue&type=script&lang=ts&"
export * from "./ot-autocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./ot-autocomplete.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ot-autocomplete.vue?vue&type=style&index=1&id=53628a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53628a72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
